import { Metamodel } from '../base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

import { format } from 'app/shared/utils/string.util';
import { TabularTypeDataset } from './tabular-type.dataset';
import { IModel } from '../base/annotation';

@Metamodel.model({
    name: adfModelTypeMap.sapBw.datasetType,
    display: [format(stringResources.ModelName_DatasetTemplate, stringResources.SapBW_DisplayText),
            format(stringResources.ModelName_DatasetsTemplate, stringResources.SapBW_DisplayText)]
})
export class SapBwCubeDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
